module.exports = __webpack_public_path__ + "static/media/clear-betslip.7363e010.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clear-betslip.svg
// module id = 2092
// module chunks = 7